import { useLegalTermDetailLazyQuery } from 'generated/graphql';



export function useLegalTermDetail() {
  const [fnRunQuery, tuple] = useLegalTermDetailLazyQuery({ fetchPolicy: 'no-cache' });

  async function fnWrappedQuery(title: string) {
    await fnRunQuery({ variables: { title } });
  }



  return {
    fnRunQuery: fnWrappedQuery,
    loading: tuple.loading,
    data: tuple.data?.legalTermDetail
  };
}
